import React, { memo } from 'react';
import NavLink from './NavLink';
import { cn } from 'lib/utils';

export interface NavigationItem {
  title: string;
  to: string;
  icon?: React.ReactNode;
}

interface NavigationProps {
  items: NavigationItem[];
  className?: string;
}

function Navigation(props: NavigationProps) {
  const { items, className } = props;

  return (
    <nav className={cn('flex items-center', className)}>
      <ul className="flex items-center space-x-6">
        {items.map((item, itemIndex) => (
          <NavLink
            key={itemIndex.toString()}
            icon={item.icon}
            title={item.title}
            to={item.to}
          />
        ))}
      </ul>
    </nav>
  );
}

export default memo(Navigation);
